import { render, staticRenderFns } from "./MocktestAttemptCardActions.vue?vue&type=template&id=23cec01f&"
import script from "./MocktestAttemptCardActions.vue?vue&type=script&lang=js&"
export * from "./MocktestAttemptCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports